import { TFunction } from 'react-i18next'

import { Discord, Docs, GitHub, Telegram, Twitter } from '../components/Icons'

export const socialLinks = [
  {
    title: 'Documentation',
    href: 'https://docs.headlessui.com',
    icon: Docs,
  },
  {
    title: 'Telegram',
    href: 'https://t.me/headlessui',
    icon: Telegram,
  },
  {
    title: 'Discord',
    href: 'https://discord.gg/QWQWQWQ',
    icon: Discord,
  },
  {
    title: 'Twitter',
    href: 'https://twitter.com/headlessui',
    icon: Twitter,
  },
  {
    title: 'GitHub',
    href: 'https://github.com',
    icon: GitHub,
  },
]

/**
 * @param {TFunction<"translation", undefined>} t
 * @return {Array} Array of navLinks with the following properties: title, href
 */
export const navLinks = (t: TFunction<'translation', undefined>) => {
  return [
    {
      title: t(`Home`),
      href: '/home',
    },
    {
      title: t(`Swap`),
      href: '/swap',
    },
    {
      title: t(`Liquidity`),
      href: '/liquidity',
    },
    {
      title: t(`Farm`),
      href: '/farm',
    },
    {
      title: t(`Vaults`),
      href: '/vaults',
    },
    {
      title: t(`Locker`),
      href: '/locker',
    },
    {
      title: t(`Disperse`),
      href: '/disperse',
    },
    {
      title: t(`Governance`),
      href: '/governance',
    },
    {
      title: t(`Analytics`),
      href: '/analytics',
    },
    {
      title: t(`api/farms`),
      href: '/api/farms',
    },
    {
      title: t(`api/prices`),
      href: '/api/prices',
    },
  ]
}
